<div mdbModal #imprimirFacturaResultado="mdb-modal" class="modal fade" style="overflow-y: auto" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Resultado del Envío
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="imprimirFacturaResultado.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="border-bottom: 1px solid #dee2e6;">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">
              Resultado
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col mt-1">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col">Documento</th>
                    <th scope="col">Folio</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Rut</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Documento</th>
                    <th scope="col">Copia Cedible</th>
                    <th scope="col">Envio PDF</th>
                    <th scope="col">Envio XML</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="100%" style="text-align: center" *ngIf="listaMovimientos?.length === 0">
                      No se encontró información
                    </td>
                  </tr>
                  <tr *ngFor="let mov of listaMovimientos">
                    <td class="text-center">{{ mov.tipo_dte_nombre }}</td>
                    <td class="text-center">{{ mov.folio }}</td>
                    <td class="text-center">{{ mov.fecha_emision | fecha}}</td>
                    <td class="text-center">{{ mov.rutFormato | rut }}</td>
                    <td>{{ mov.cliente_nombre }}</td>
                    <td class="text-center">
                      <span class="value" *ngIf="!mov.documento">
                        <mdb-badge pill="true" danger="true">X</mdb-badge>
                      </span>
                      <span class="value" *ngIf="mov.documento">
                        <mdb-badge pill="true" success="true">
                          <mdb-icon fas icon="check"></mdb-icon>
                        </mdb-badge>
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="value" *ngIf="!mov.copia_cedible">
                        <mdb-badge pill="true" danger="true">X</mdb-badge>
                      </span>
                      <span class="value" *ngIf="mov.copia_cedible">
                        <mdb-badge pill="true" success="true">
                          <mdb-icon fas icon="check"></mdb-icon>
                        </mdb-badge>
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="value" *ngIf="!mov.envio_pdf">
                        <mdb-badge pill="true" danger="true">X</mdb-badge>
                      </span>
                      <span class="value" *ngIf="mov.envio_pdf">
                        <mdb-badge pill="true" success="true">
                          <mdb-icon fas icon="check"></mdb-icon>
                        </mdb-badge>
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="value" *ngIf="!mov.envio_xml">
                        <mdb-badge pill="true" danger="true">X</mdb-badge>
                      </span>
                      <span class="value" *ngIf="mov.envio_xml">
                        <mdb-badge pill="true" success="true">
                          <mdb-icon fas icon="check"></mdb-icon>
                        </mdb-badge>
                      </span>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="imprimirFacturaResultado.hide()" mdbWavesEffect>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-modal-confirm></app-modal-confirm>